// extracted by mini-css-extract-plugin
export var carousel = "content-carousel-module--carousel--7437c";
export var carouselItem = "content-carousel-module--carouselItem--d2bb4";
export var carouselItemNarrow = "content-carousel-module--carouselItemNarrow--ea00b";
export var carouselTrack = "content-carousel-module--carouselTrack--cee77";
export var contentCarousel = "content-carousel-module--contentCarousel--536db";
export var showCarouselButton = "content-carousel-module--showCarouselButton--61621";
export var stackedGrid = "content-carousel-module--stackedGrid--d1372";
export var styledBfcmContentCard = "content-carousel-module--styledBfcmContentCard--65011";
export var styledButtons = "content-carousel-module--styledButtons--95247";
export var styledButtonsLeft = "content-carousel-module--styledButtonsLeft--a5968";
export var styledCarouselButton = "content-carousel-module--styledCarouselButton--d41c9";
export var styledGrid = "content-carousel-module--styledGrid--c11fe";
export var styledHeadline = "content-carousel-module--styledHeadline--68d36";
export var styledHeadlineActionRow = "content-carousel-module--styledHeadlineActionRow--33e74";
export var styledHeadlines = "content-carousel-module--styledHeadlines--4005a";
export var styledHeadlinesLeft = "content-carousel-module--styledHeadlinesLeft--771bd";
export var styledSchmalHeadline = "content-carousel-module--styledSchmalHeadline--af965";
export var styledSubheadline = "content-carousel-module--styledSubheadline--8933d";
export var styledVimeoPlayer = "content-carousel-module--styledVimeoPlayer--12fe7";